import { GET_PREORDER_FAILURE, GET_PREORDER_SUCCESS, GET_PREORDER_CALLED, GET_PREORDER_ABORT, CLEAR_PARTNER_CART_ERRORS } from '../constants';
export var getPreorderCalled = function getPreorderCalled(payload) {
  return {
    type: GET_PREORDER_CALLED,
    payload: payload
  };
};
export var getPreorderSuccess = function getPreorderSuccess(payload) {
  return {
    type: GET_PREORDER_SUCCESS,
    payload: payload
  };
};
export var getPreorderFailure = function getPreorderFailure(error) {
  return {
    type: GET_PREORDER_FAILURE,
    error: true,
    payload: error
  };
};
export var getPreorderAbort = function getPreorderAbort(retries) {
  return {
    type: GET_PREORDER_ABORT,
    payload: {
      message: 'Partner cart polling aborted. Past max retries.',
      // need to discuss if we expose this message or what message
      retries: retries
    },
    error: true
  };
};
export var clearPartnerCartErrors = function clearPartnerCartErrors() {
  return {
    type: CLEAR_PARTNER_CART_ERRORS
  };
};